module.exports = __webpack_public_path__ + "img/5-2.a6fd740f.png";